import { useNavigate } from 'react-router-dom';

import useGoBack from '@/hooks/useGoBack';
import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/SaveAsDraftDialog.css';

// mode: 'article' or 'post'
export default function SaveAsDraftDialog({
  formState,
  open,
  close,
  mode = 'article',
  onSaveDraft,
}) {
  const t = useTranslations('common.forms.board_editor');
  const navigate = useNavigate();

  function discardChanges() {
    close();       // close the dialog
    navigate(-1);  // leave the editor without saving
  }

  const goBackHandler = useGoBack(
    `/profile/board?view=${mode==="post" ? 'posts' : 'articles'}`
  );

  function goToDraftEditor() {
    goBackHandler(); // go back to the board
    // navigate to the draft editor with the draft data
  }

  async function saveDraft() {
    if (mode === 'article' && !formState.post_title) {
      // only articles require a title
      alert(t('article_title_required'));
      return;
    }

    const result = await onSaveDraft?.();

    if (result?.blocked === 'uploading') {
      alert(t('wait_for_uploads'));
      return;
    }

    if (result?.response?.ok) {
      goToDraftEditor();
    }
  }

  return (
    <GenericPopup
      className="save-as-draft-popup"
      open={open}
      opacity
      onCloseAction={discardChanges}
      closeButtonText={(
        <>
          <span className="save-as-draft-popup__btn-label save-as-draft-popup__btn-label--desktop">
            {t('discard_changes')}
          </span>
          <span className="save-as-draft-popup__btn-label save-as-draft-popup__btn-label--mobile">
            {t('discard')}
          </span>
        </>
      )}
      onConfirm={saveDraft}
      confirmButtonText={(
        <>
          <span className="save-as-draft-popup__btn-label save-as-draft-popup__btn-label--desktop">
            {t('save_as_draft')}
          </span>
          <span className="save-as-draft-popup__btn-label save-as-draft-popup__btn-label--mobile">
            {t('save')}
          </span>
        </>
      )}
    >
      <div className="artwork-confirmation-dialog-popup__header">
        <Text className="confirmation-dialog-popup__header-text">
          {t('save_as_draft_question')}
        </Text>
        <XIcon
          className="artwork-confirmation-dialog-popup__close"
          onClick={close}
        />
      </div>

      {/* body */}
      <Text
        className="confirmation-dialog-popup__text"
        paragraph
      >
        {t('leave_without_saving')}
      </Text>
    </GenericPopup>
  );
}
